import { useCart } from '../context/CartContext';
import { X, Plus, Minus, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { formatFCFA } from '../lib/currency';

export default function CartDrawer() {
  const { items, totalPrice, isOpen, setIsOpen, updateQuantity, removeItem } = useCart();

  if (!isOpen) return null;

  return (
    <>
      <div data-testid="cart-overlay" className="fixed inset-0 bg-black/30 z-[60]" onClick={() => setIsOpen(false)} />
      <div data-testid="cart-drawer" className="fixed top-0 right-0 h-full w-full max-w-md bg-[#F5F0E8] z-[70] flex flex-col shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-black/10">
          <h2 className="font-serif text-2xl font-light" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Votre Panier</h2>
          <button data-testid="close-cart-drawer" onClick={() => setIsOpen(false)} className="p-1 hover:opacity-50 transition-opacity">
            <X size={20} strokeWidth={1.5} />
          </button>
        </div>

        {/* Items */}
        <div className="flex-1 overflow-y-auto p-6">
          {items.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center">
              <p className="text-black/40 text-sm mb-4">Votre panier est vide</p>
              <button onClick={() => setIsOpen(false)} className="btn-secondary text-xs">
                Continuer les Achats
              </button>
            </div>
          ) : (
            <div className="space-y-6">
              {items.map(item => (
                <div key={item.product_id} data-testid={`cart-item-${item.product_id}`} className="flex gap-4">
                  <div className="w-20 h-20 bg-[#EDE8DE] flex-shrink-0">
                    <img src={item.product?.image_url} alt={item.product?.name} className="product-image w-full h-full object-cover" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-serif text-base font-normal truncate" style={{ fontFamily: 'Cormorant Garamond, serif' }}>{item.product?.name}</h4>
                    <p className="text-sm font-semibold mt-1">{formatFCFA(item.product?.price || 0)}</p>
                    <div className="flex items-center gap-3 mt-2">
                      <button data-testid={`decrease-qty-${item.product_id}`} onClick={() => updateQuantity(item.product_id, item.quantity - 1)} className="w-7 h-7 border border-black/20 flex items-center justify-center hover:bg-black hover:text-white transition-colors">
                        <Minus size={12} />
                      </button>
                      <span className="text-sm font-semibold w-6 text-center" style={{ color: '#B80000' }}>{item.quantity}</span>
                      <button data-testid={`increase-qty-${item.product_id}`} onClick={() => updateQuantity(item.product_id, item.quantity + 1)} className="w-7 h-7 border border-black/20 flex items-center justify-center hover:bg-black hover:text-white transition-colors">
                        <Plus size={12} />
                      </button>
                      <button data-testid={`remove-item-${item.product_id}`} onClick={() => removeItem(item.product_id)} className="ml-auto text-xs text-black/40 hover:text-black transition-colors uppercase tracking-widest">
                        Supprimer
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div className="border-t border-black/10 p-6 space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-xs uppercase tracking-[0.2em] font-bold text-black/50">Sous-total</span>
              <span className="text-lg font-semibold">{formatFCFA(totalPrice)}</span>
            </div>
            <Link
              to="/cart"
              data-testid="view-cart-link"
              onClick={() => setIsOpen(false)}
              className="btn-primary flex items-center justify-center gap-2 w-full text-center"
            >
              Voir le Panier <ArrowRight size={14} />
            </Link>
          </div>
        )}
      </div>
    </>
  );
}
